import axios from "axios";
import { Capacitor } from "@capacitor/core";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cihazın mevcut FCM token'ı (çıkışta backend'den silmek için hatırlanır).
let _currentToken = null;
let _listenersReady = false;

// Native uygulamada push bildirimlerini kur: izin iste, token'ı backend'e
// kaydet, bildirime dokununca ilgili sayfaya git. Web'de sessizce no-op.
// Girişten SONRA çağrılmalı (token kaydı auth ister).
export async function registerPush() {
  if (!Capacitor.isNativePlatform()) return;
  try {
    const { FirebaseMessaging } = await import("@capacitor-firebase/messaging");

    const perm = await FirebaseMessaging.requestPermissions();
    if (perm.receive !== "granted") return;

    const { token } = await FirebaseMessaging.getToken();
    if (!token) return;
    _currentToken = token;
    await axios.post(`${API}/me/push-token`, {
      token,
      platform: Capacitor.getPlatform(),
    });

    if (!_listenersReady) {
      _listenersReady = true;
      // Bildirime dokunuldu → data.link'teki sayfaya git.
      FirebaseMessaging.addListener("notificationActionPerformed", (event) => {
        const link = event?.notification?.data?.link;
        if (link && typeof link === "string" && link.startsWith("/")) {
          window.location.href = link;
        }
      });
      // Token yenilenirse sessizce güncelle.
      FirebaseMessaging.addListener("tokenReceived", async ({ token: fresh }) => {
        if (!fresh || fresh === _currentToken) return;
        _currentToken = fresh;
        try {
          await axios.post(`${API}/me/push-token`, {
            token: fresh,
            platform: Capacitor.getPlatform(),
          });
        } catch { /* sonraki girişte tekrar denenir */ }
      });
    }
  } catch {
    /* push kurulamadıysa (izin yok / iOS APNs yok) uygulama normal çalışır */
  }
}

// Çıkışta bu cihazın token'ını sil — logout sonrası push gelmesin.
export async function unregisterPush() {
  if (!Capacitor.isNativePlatform() || !_currentToken) return;
  try {
    await axios.delete(`${API}/me/push-token`, { data: { token: _currentToken } });
  } catch { /* best-effort */ }
  _currentToken = null;
}
